const {validateEmail} = require("mytime-common/forms/validate-email");
const {validatePhone} = require("mytime-common/forms/validate-phone");
const {validatePhoneInternational} = require("mytime-common/forms/validate-phone-international");
const {getPathData} = require("mytime-common/arr-path");

const email = {
    name: "email",
    validate: validateEmail,
};
exports.email = email;

const requireUnless = (path) => ({
    name: "requireUnless",
    validate: (value, data) => {
        return value || getPathData(data, path.split("."));
    },
});
exports.requireUnless = requireUnless;



const humanName = {
    name: "humanName",
    validate: (value) => {
        if (value == null || value === "") {
            return true;
        }

        const containsAny = (str, sequence) => {
            for (let i = 0; i < sequence.length; i++) {
                const c = sequence[i];
                if (str.indexOf(c) > -1) {
                    return true;
                }
            }
            return false;
        };

        return !containsAny(value, ",/?;:\\\"[{]}=+_)(*&^%$#@!~<>") && !/[0-9]/.test(value);
    },
};

exports.humanName = humanName;

const phone = {
    name: "phone",
    validate: validatePhone,
};

exports.phone = phone;

const phoneInternational = {
    name: "phoneInternational",
    validate: validatePhoneInternational,
};

exports.phoneInternational = phoneInternational;

const dob = {
    name: "dob",
    validate: (value) => {
        if (value == null || value === "") {
            return true;
        }

        const containsOnly = (str, sequence) => {
            for (let i = 0; i < str.length; i++) {
                const c = str[i];
                if (sequence.indexOf(c) === -1) {
                    return false;
                }
            }
            return true;
        };

        return containsOnly(value, "/-0123456789") && value.length === 10;
    },
};

exports.dob = dob;
